<template>
    <div :class="'div-part-status ml-2' + partStatusClass  "></div>
</template>
<style scoped lang="scss">
    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }

    .div-part-status {
		width: 50%;
		height: 15px;
		border-radius: 5px;
        animation: blinker 3s linear infinite;

		&.part-status-success {
			background-color: #00ff00;
		}

		&.part-status-danger {
			background-color: #ff0000;
		}

        &.part-status-warning {
			background-color: #e5ff00;
		}
	}
</style>
<script>
export default {
    props: {
        partId: {
            type: [Number, String],
        },
        gap: {
            type: [Number, String]
        }
    },
    data() {
        return {
            isLoading : false,
            successData : {},
            warningData : {},
        }
    },
    mounted() {
        if (this.gap <= 0) {
            this.getRemarksWarningIndicator();
        } else {
            this.getRemarksSuccessIndicator();
        }
    },
    computed : {
        partStatusClass() {
            if (this.gap <= 0) {
                if (this.warningData != null) {
                    if (this.warningData.status) {
                        return " part-status-warning";        
                    }
                }
                return " part-status-danger";
            } else {
                if (this.successData != null) {
                    if (this.successData.status) {
                        return " part-status-success";        
                    }
                }
            }
        }
    },
    methods : {
        getRemarksSuccessIndicator() {
			this.isLoading = true;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandondeliverypartstatussuccess/${this.partId}`).then(result => {
				if (result != null) {
					this.successData = result.data;
				}
				this.isLoading = false;
				return true;
			}).catch(function (error) {
				this.isLoading = false;
			});
		},
        getRemarksWarningIndicator() {
			this.isLoading = true;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandondeliverypartstatuswarning/${this.partId}`).then(result => {
				if (result != null) {
					this.warningData = result.data;
				}
				this.isLoading = false;
				return true;
			}).catch(function (error) {
				this.isLoading = false;
			});
		},
    }

}
</script>